"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.Image = function (_a) {
    var src = _a.src, _b = _a.title, title = _b === void 0 ? "" : _b;
    return react_1.default.createElement("img", { src: src, title: title });
};
exports.Image.displayName = "Image";
exports.Image.editableFields = [
    {
        name: "shape",
        assign: function (block, value) {
            block.props.shape = value;
        },
        type: "enum",
        defaultValue: ["rectangle"],
        values: [
            ["Circular", "circle"],
            ["Rounded", "rounded"],
            ["Rectangular", "rectangle"]
        ],
        help: ""
    },
    {
        name: "Source",
        assign: function (block, value) {
            block.props.src = value;
        },
        type: "image",
        help: ""
    }
];
